import React, { FC } from 'react';

import BoxedList, { IBoxedListIndex } from '../../molecules/boxed-list/boxed-list';
import StripeHeader from '../../atoms/stripe-header/stripe-header';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './archive-index.scss';

export interface IArchiveIndex {
  title: string;
  boxList: IBoxedListIndex[];
}

const classNames = (className: string): IClassNames => {
  return makeClassNames({
    archiveIndex: className,
  });
};
const cn = classNames('archive-index');
const ArchiveIndex: FC<IArchiveIndex> = ({ title, boxList }) => {
  return (
    <div className={cn.archiveIndex}>
      <StripeHeader title={title} hasBG />
      {boxList.map((election) => {
        const { list, title } = election;
        return <BoxedList key={title} list={list} title={title} />;
      })}
    </div>
  );
};
export default ArchiveIndex;
